/**
 * Contains various form-related manipulations
 *
 * @component
 */

import ClassLogger from 'ClassLogger';

class FormHandler {
    getClassName() {return 'FormHandler';}
    constructor(){
        let self = this;
        self.logger = ClassLogger(self, true);

        // initiate scripts
        self.dynmaicallyVisibleInputs();
        self.textAreaCounter();
        self.floatingLabels();
        self.jobsFilter();
        self.inputDependants();
        self.currentCheckboxes();
        // disable checkProgress for now as UX is not ideal (contrast, color, labels etc)
        //self.checkProgress();

        /*
         * Add a `has-select` class to <select> on change (used white `c-form--white` to make text color non-transparent)
         */
        $('select').each(function(i, select){
            if ($('option:selected', this).last().val() != "") $(this).addClass('has-selected');
        });
        $('select').on('change', function(e){
            $(this).addClass('has-selected');
        });

        $('.c-contactselect').on('change', '.c-contactselect__item input[type="radio"]', function(e){
            $('.c-contactselect .c-contactselect__item').removeClass('c-contactselect__item--checked');
            $(this).parents('.c-contactselect__item').addClass('c-contactselect__item--checked');
        });

    }


    dynmaicallyVisibleInputs() {
        $('[data-dynmaicvisibleinputs]').each(function(e, container){
            let $container = $(container);

            // if we want to show 1 empty input, set this to true
            let leaveFirstEmptyVisible = true;

            // go through all inputs
            $container.find('[data-input]').each(function(i, element){
                let $element = $(element);
                let $input = $element.find('input,select,textarea').first();

                // hide empty inputs
                if ($input.val() === '') {
                    if (leaveFirstEmptyVisible === false) {
                        $element.hide();
                    }
                    leaveFirstEmptyVisible = false;
                }

                // on keyup, show the next input (listener only executed once)
                $input.one('keyup', function(e){
                    $element.next('[data-input]').show();
                });
            });
        });
    }

    jobsFilter(){

        /*
         * handling of the job-filtercritera (careerlevel, jobtype, jobarea)
         * This handles the job-filtercritera in the hero, where the selects are transparent to fix the font-size issue in some browsers
         */

        $('.c-job-filtercriteria--hero .c-job-filtercriteria__item').each(function(i, item){
            if ($('select option:selected', item).length === 0) {
                $('select option', item).first().prop('selected', true);
            }

            $('select', item).on('change', function(e){
                let $option = $('option:selected', this);
                let newvalue = $option.text();
                $('.c-job-filtercriteria__selected', item).text(newvalue.replace(/ *\([^)]*\) */g, ""));
            });
        });

        $('.c-job-filtercriteria__item').each(function(i, item){
            $('select', item).on('change', function(e){
                let $option = $('option:selected', this);
                if (typeof $option.data('intro') !== 'undefined') $('.c-job-filtercriteria__intro', item).text($option.data('intro'));
            });
            // manually trigger change during initialization, to update intro and __selected text
            $('select', item).trigger('change');
        });


        /*
         * small screens: Filter options are hidden until the filter button is clicked. Used on the Job Listing page.
         */
        $('[data-jobsfilterbutton]').each(function(item,component){

            let options = $(component).data('jobsfilterbutton');
            let $target = $('.'+options.targetclass);

            $(component).on('click',function(e){
                e.preventDefault();
                $target.toggleClass('has-max-height');
            })

        });

    }

    floatingLabels(){

        /*
         * Floating labels
         * see https://foundation.zurb.com/building-blocks/blocks/floated-label-wrapper.html
         */
        $('.u-floated-label-wrapper input').each(function(i, item) {
            $(item).on('checkval', function() {
                let label = $(item).prev('label');
                if ($(item).val() !== '') {
                    label.addClass('has-show-label');
                } else {
                    label.removeClass('has-show-label');
                }
            }).on('keyup', function() {
                $(this).trigger('checkval');
            });
        });

    }

    textAreaCounter(){
        /*
         * Textarea Counter
         */

        $('[data-textarea-counter]').each(function(item,component){

            let maxCount = $(component).data('textarea-counter');
            let $messageCanvas = $(component).next('[data-textarea-counter-message]');

            //init
            if (!$(component).val()) {
                $messageCanvas.prepend('noch 0 von ' + maxCount);
            } else {
                $messageCanvas.text('noch ' + (maxCount - $(component).val().length) + ' von ' + maxCount);
            }

            // tracking
            let countReturns = 0;


            $(component).keyup(function(e){
                // replace double empty lines
                $(component).val($(component).val().replace(/\n\n\n/g, "\n\n"));
/*
                // handle returns
                let keycode = (e.keyCode ? e.keyCode : e.which);

                if (keycode === 13) {
                    // count linebreaks
                    let lines = $(component).val().split("\n");
                    // remove last line break if above limit
                    if (lines.length > 25) {
                        $(component).val(text.replace(/\n$/g, " "));
                    }
                }
*/
                // counter
                $messageCanvas.text('noch ' + (maxCount - $(component).val().length) + ' von ' + maxCount);

            })

        });

    }

    inputDependants(){
        /*
        * Connects two input fields together. If the first one has a value, than the second one becomes required
        */

         $('[data-inputdependant]').each(function(i,component){

            let dependant = $(component).data('inputdependant');
            let $dependant = $('input[name="' + dependant + '"]');

            let value = $(component).val();
            if(value != '') { // checks on page load
                $dependant.prop('required',true);
            }

            $(component).on('change',function(){

                let value = $(component).val();
                if(value != '') {
                    $dependant.prop('required',true);
                }

            })

         });

    }

    currentCheckboxes(){
        /*
         * Profile edit page - if current checkbox is selected, set end date to 0 and hide it.
         */
        let self = this;

        $('[data-currentexperience]').each(function(i,component){

            self.currentCheckboxLogic(component);

            $(component).on('click',function(){

                self.currentCheckboxLogic(component);

            })

        });

    }

    currentCheckboxLogic(component){
        /*
         * Profile edit page - inside function for currentCheckboxes function
         */

        let $current = $(component);
        let targetId = $current.data('currentexperience');

        if($current.is(':checked')) {
            // hide and set value to 0
            $('#'+targetId).parent().addClass('hide');
            $('#'+targetId).val('');

        }else{
            $('#'+targetId).parent().removeClass('hide');

        }


    }

    checkProgress() {

        let srcEmptyFields = $('[data-emptyfields]').attr('data-emptyfields');

        if(srcEmptyFields !== '' && srcEmptyFields !== undefined) {

            let emptyFieldNames = srcEmptyFields.split(',');

            emptyFieldNames.forEach(function(value){
                console.warn("Hinting field " + value);
                $('input[name="' + value + '"]').addClass('u-progress-empty');
                $('textarea[name="' + value + '"]').addClass('u-progress-empty');
                $('input[name="' + value + '[]"][value=""]').addClass('u-progress-empty');
                $('input[name="' + value + '_*"][value=""]').addClass('u-progress-empty');
            });

        }

    }
}

export default new FormHandler();
